import {RootState} from "../store";

export const getLanguage = (state: RootState) => {
    return state.appReducer.language
}

export const getIsAppLoading = (state: RootState) => {
    return state.appReducer.isLoading
}

export const getIsAppInitialized = (state: RootState) => {
    return state.appReducer.isInitialized
}

export const getHeightHeader = (state: RootState) => {
    return state.appReducer.heightHeader
}
